import { HttpClient } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmLeadsService {

  constructor(private http: HttpClient) { }

  getAllTypes(){
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
  }

  getEmailMapping(moduleId: number){
    return this.http.get<any>(`${environment.apiUrl}EmailToTicketConfig?moduleId=${moduleId}`)
  }

  addEditEmailMapping(moduleId: number, data){
    return this.http.put<any>(`${environment.apiUrl}EmailToTicketConfig/ChannelMapper?moduleId=${moduleId}`, data)
        .toPromise()
        .then((res) => res);
  }

  deleteEmailMapping(moduleId: number, channelId){
    return this.http.delete<any>(`${environment.apiUrl}EmailToTicketConfig/ChannelMapper?moduleId=${moduleId}&channelId=${channelId}`)
        .toPromise()
        .then((res) => res);
  }

  getChannelByModuleId(moduleId){
    return this.http.get<any>( `${environment.configUrl}v2/Channel/SelectList/Module/${moduleId}`);
  }
}
